import { render } from "./NotesDocumentsBlock.vue?vue&type=template&id=d4d9e2dc&scoped=true"
import script from "./NotesDocumentsBlock.vue?vue&type=script&lang=js"
export * from "./NotesDocumentsBlock.vue?vue&type=script&lang=js"

import "./NotesDocumentsBlock.vue?vue&type=style&index=0&id=d4d9e2dc&scoped=true&lang=css"

import exportComponent from "/tmp/build_1a3e5399/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4d9e2dc"]])

export default __exports__